import { com } from '@eidu/web'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import Link from '../domain/entity/Link'
import assetResourceLinkKey = com.eidu.sharedlib.entity.assetResourceLinkKey

export const getResourceKeyFromEntity = (entity: EntityWithLabelAndRelated): string | undefined =>
  entity.entity.links.asJsReadonlyMapView().get(assetResourceLinkKey)

export const getEntityLinkFromResourceKey = (resourceKey: string): Link => ({
  key: assetResourceLinkKey,
  value: resourceKey,
})
